import React, { useState } from "react";
import XlsxPopulate from "xlsx-populate/browser/xlsx-populate";

function AllEmployeesReports() {
  const SERVER_URL = process.env.REACT_APP_API_URL;
  const token = JSON.parse(localStorage.getItem("key"));
  const [loader, setLoader] = useState(false);
  const [empType, setEmpType] = useState("");
  const [showMessage, setShowMessage] = useState(false);
  const DownLoadUserReports = () => {
    if (empType === "1") {
      setLoader(true);
      console.log("Downloading all employees report...");
      getAllUsersList();
    }
    if (empType === "2") {
      setLoader(true);
      console.log("Downloading active employees report...");
      getActiveUsersList();
    }
    if (empType === "3") {
      setLoader(true);
      console.log("Downloading inactive employees report...");
      getInactiveUsersList();
    }
  };

  const getAllUsersList = async () => {
    try {
      const response = await fetch(`${SERVER_URL}api/reports/getalluserslist`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          authorization: `Bearer ${token.value}`,
        },
      });

      if (!response.ok) throw new Error("Failed to fetch users");

      const data = await response.json();
      console.log("Active Users Data:", data);
      downloadExcelAllUserReport(data.results || []);
    } catch (error) {
      console.error("Error fetching all users:", error);
      setLoader(false);
    }
  };

  const downloadExcelAllUserReport = async (resultData) => {
    if (!resultData || resultData.length === 0) {
      setShowMessage(true);
      setLoader(false);
      setTimeout(() => setShowMessage(false), 1000);
      console.warn("No data found for Excel export");
      return;
    }
    try {
      setLoader(true);
      const today = new Date().toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });

      const workbook = await XlsxPopulate.fromBlankAsync();
      const sheet = workbook.sheet(0);

    sheet
  .range("A1:E1")
  .merged(true)
  .value("All Users Report")
  .style({
    bold: true,
    fontSize: 16,
    horizontalAlignment: "center",
    verticalAlignment: "center",
  });

      // Meta info
      sheet.cell("A2").value("Report Generated Date:").style({ bold: true });

      sheet.cell("B2").value(today);

      sheet
        .cell("A3")
        .value("Total Active And Inactive Users")
        .style({ bold: true });

      sheet
        .cell("B3")
        .value(resultData.length)
        .style({ bold: true, horizontalAlignment: "left" });

      // Header
      const headerRow = [
        "Employee Code",
        "Employee Name",
        "Email",
        "Department Name",
        "Status",
      ];
      sheet.cell("A5").value([headerRow]);
      sheet.range("A5:E5").style({
        bold: true,
        fill: "FFD966",
        border: true,
        horizontalAlignment: "center",
      });

      // Data rows
      resultData.forEach((u, index) => {
        const fullName =
          u?.name ??
          u?.fullName ??
          [u?.fname, u?.mname, u?.lname].filter(Boolean).join(" ") ??
          "";

        const rowIndex = index + 6; // Start from row 6
        sheet.cell(`A${rowIndex}`).value(u?.user_code ?? "");
        sheet.cell(`B${rowIndex}`).value(fullName);
        sheet.cell(`C${rowIndex}`).value(u.email ?? "");
        sheet.cell(`D${rowIndex}`).value(u?.deptName ?? "");
        sheet.cell(`E${rowIndex}`).value(u?.status ?? "");

        // if ((u?.status || "").toLowerCase() === "inactive") {
        //   sheet.range(`A${rowIndex}:D${rowIndex}`).style({
        //     fill: "FFCCCC", // light red background
        //   });
        // }
      });

      // Auto column width
      // [1, 2, 3, 4].forEach((col) => {
      //   sheet.column(col).width(30);
      // });
      sheet.column(1).width(30);
      sheet.column(2).width(40);
      sheet.column(3).width(42);
      sheet.column(4).width(45);
      sheet.column(5).width(10);

      // Export
      const blob = await workbook.outputAsync();
      const url = window.URL.createObjectURL(blob);
      const anchor = document.createElement("a");
      anchor.href = url;
      anchor.download = "Active_and_Inactive_Users_List.xlsx";
      document.body.appendChild(anchor);
      anchor.click();
      anchor.remove();
      window.URL.revokeObjectURL(url);
      setLoader(false);
    } catch (error) {
      console.error("Error generating Excel:", error);
    } finally {
      setLoader(false);
    }
  };

  const getActiveUsersList = async () => {
    try {
      const response = await fetch(
        `${SERVER_URL}api/reports/getactiveuserslist`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            authorization: `Bearer ${token.value}`,
          },
        }
      );

      if (!response.ok) throw new Error("Failed to fetch users");

      const data = await response.json();
      console.log("Active Users Data:", data);
      downloadExcelActiveUserReport(data.results || []);
    } catch (error) {
      console.error("Error fetching active users:", error);
      setLoader(false);
    }
  };
  const getInactiveUsersList = async () => {
    try {
      const response = await fetch(
        `${SERVER_URL}api/reports/getinactiveuserslist`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            authorization: `Bearer ${token.value}`,
          },
        }
      );

      if (!response.ok) throw new Error("Failed to fetch users");

      const data = await response.json();
      console.log("Active Users Data:", data);
      downloadExcelInactiveUserReport(data.results || []);
    } catch (error) {
      setShowMessage(true);
      setLoader(false);
      setTimeout(() => setShowMessage(false), 1000);
      console.error("Error fetching active users:", error);
      setLoader(false);
    }
  };
  const downloadExcelActiveUserReport = async (resultData) => {
    if (!resultData || resultData.length === 0) {
      setShowMessage(true);
      setLoader(false);
      setTimeout(() => setShowMessage(false), 1000);
      console.warn("No data found for Excel export");
      return;
    }

    try {
      setLoader(true);
      const today = new Date().toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });

      const workbook = await XlsxPopulate.fromBlankAsync();
      const sheet = workbook.sheet(0);

      // Title
      // sheet.cell("A1").value("Active Users Report");
      // sheet.cell("A1").style({ bold: true, fontSize: 16 });
      // sheet.range("A1:C1").merged(true).style({ horizontalAlignment: "center" });

      sheet.range("A1:D1").merged(true).value("Active Users Report").style({
        bold: true,
        fontSize: 16,
        horizontalAlignment: "center",
        verticalAlignment: "center",
      });

      // Meta info
      sheet.cell("A2").value("Report Generated Date:").style({ bold: true });

      sheet.cell("B2").value(today);

      sheet.cell("A3").value("Total Active Users:").style({ bold: true });

      sheet
        .cell("B3")
        .value(resultData.length)
        .style({ bold: true, horizontalAlignment: "left" });

      // Header
      const headerRow = ["Employee Code", "Employee Name","EMAIL", "Department Name"];
      sheet.cell("A5").value([headerRow]);
      sheet.range("A5:D5").style({
        bold: true,
        fill: "FFD966",
        border: true,
        horizontalAlignment: "center",
      });

      // Data rows
      resultData.forEach((u, index) => {
        const fullName =
          u?.name ??
          u?.fullName ??
          [u?.fname, u?.mname, u?.lname].filter(Boolean).join(" ") ??
          "";

        const rowIndex = index + 6; // Start from row 6
        sheet.cell(`A${rowIndex}`).value(u?.user_code ?? "");
        sheet.cell(`B${rowIndex}`).value(fullName);
        sheet.cell(`C${rowIndex}`).value(u.email ?? "");
        sheet.cell(`D${rowIndex}`).value(u?.deptName ?? "");
      });

      // Auto column width
      // [1, 2, 3,4].forEach((col) => {
      //   sheet.column(col).width(30);
      // });
      sheet.column(1).width(25);
      sheet.column(2).width(32);
      sheet.column(3).width(45);
      sheet.column(4).width(45);

      // Export
      const blob = await workbook.outputAsync();
      const url = window.URL.createObjectURL(blob);
      const anchor = document.createElement("a");
      anchor.href = url;
      anchor.download = "ActiveUsersReport.xlsx";
      document.body.appendChild(anchor);
      anchor.click();
      anchor.remove();
      window.URL.revokeObjectURL(url);
      setLoader(false);
    } catch (error) {
      console.error("Error generating Excel:", error);
    } finally {
      setLoader(false);
    }
  };
  const downloadExcelInactiveUserReport = async (resultData) => {
    if (!resultData || resultData.length === 0) {
      setShowMessage(true);
      setLoader(false);
      setTimeout(() => setShowMessage(false), 1000);
      console.warn("No data found for Excel export");
      return;
    }

    try {
      setLoader(true);
      const today = new Date().toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });

      const workbook = await XlsxPopulate.fromBlankAsync();
      const sheet = workbook.sheet(0);

      // ===== Title =====
      sheet.range("A1:D1").merged(true).value("Inactive Users Report").style({
        bold: true,
        fontSize: 16,
        horizontalAlignment: "center",
        verticalAlignment: "center",
      });

      // ===== Meta Info =====
      sheet.cell("A2").value("Report Generated Date:").style({ bold: true });
      sheet.cell("B2").value(today);

      sheet.cell("A3").value("Total Inactive Users:").style({ bold: true });
      sheet.cell("B3").value(resultData.length).style({
        bold: true,
        horizontalAlignment: "left",
      });

      // ===== Table Header =====
      const headerRow = ["Employee Code",  "Employee Name", "EMAIL", "Department Name"];
      sheet.cell("A5").value([headerRow]);
      sheet.range("A5:D5").style({
        bold: true,
        fill: "FFD966",
        border: true,
        horizontalAlignment: "center",
      });

      // ===== Data Rows =====
      resultData.forEach((u, index) => {
        const fullName =
          u?.name ??
          u?.fullName ??
          [u?.fname, u?.mname, u?.lname].filter(Boolean).join(" ") ??
          "";

        const rowIndex = index + 6; // Start from row 6
        sheet.cell(`A${rowIndex}`).value(u?.user_code ?? "");
        sheet.cell(`B${rowIndex}`).value(fullName);
        sheet.cell(`C${rowIndex}`).value(u.email ?? "");
        sheet.cell(`D${rowIndex}`).value(u?.deptName ?? "");
      });

      // ===== Auto Column Width =====
      // [1, 2, 3].forEach((col) => sheet.column(col).width(30));
      sheet.column(1).width(24)
      sheet.column(2).width(30)
      sheet.column(3).width(42)
      sheet.column(4).width(45)

      // ===== Export =====
      const blob = await workbook.outputAsync();
      const url = window.URL.createObjectURL(blob);
      const anchor = document.createElement("a");
      anchor.href = url;
      anchor.download = "InactiveUsersReport.xlsx";
      document.body.appendChild(anchor);
      anchor.click();
      anchor.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error generating Excel:", error);
    } finally {
      setLoader(false);
    }
  };

  return (
    <div className="row">
      <div className="col-md-3">
        <div className="form-blk mb25">
          <div className="form-label">Export Employee Status Report</div>
          <div className="form-input">
            <select
              className="form-select"
              onChange={(e) => setEmpType(e.target.value)}
            >
              <option value="">Select Report Type...</option>
              <option value="1">All Employees (Active & Inactive)</option>
              <option value="2">Active Employees</option>
              <option value="3">Inactive Employees</option>
            </select>
          </div>
        </div>
        {showMessage && (
          <span style={{ color: "red" }}>Data not available</span>
        )}
      </div>

      <div className="col-md-3 mb25">
        <div className="form-blk">
          <label className="h22"></label>
          <div className="form-input">
            <button
              className="btn_5"
              disabled={loader}
              onClick={DownLoadUserReports}
            >
              {loader && <i className="fa fa-circle-o-notch fa-spin mr05"></i>}
              Download
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AllEmployeesReports;
